import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import { formatDate } from '../../../config/appConfig';
import { moduleConfig as wrhConfig } from '../../wrh/config';
import { useWrhDays, type WrhDay } from '../../wrh/useData';
import GenericListWidget from './GenericListWidget';

const WrhRecentSheets: React.FC<{
  limit?: number;
  embedded?: boolean;
  settings?: Record<string, unknown>;
}> = ({ limit = 5, embedded, settings }) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useWrhDays(undefined, 1, 50, {
    sortKey: 'workDate',
    sortDirection: 'desc',
  });

  const items = (data ?? []).slice(0, effectiveLimit);

  return (
    <GenericListWidget<WrhDay>
      title="WRH · Recent sheets"
      viewAllPath="/wrh"
      data={items}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No WRH sheets"
      getItemKey={(d) => d.id}
      embedded={embedded}
      renderItem={(day) => (
        <div
          onClick={() =>
            navigate(
              wrhConfig.module.route.sheetForDay({
                vesselId: day.vesselId,
                workDate: day.workDate,
              }),
            )
          }
          className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
        >
          <div className="min-w-0">
            <p className={`text-sm font-medium truncate ${colors.text}`}>
              {day.vessel?.vesselName || `Vessel #${day.vesselId}`}
            </p>
            <p className={`text-xs ${colors.textMuted}`}>
              {formatDate(day.workDate)} · {day.status}
              {(day.ncCount ?? 0) > 0 ? ` · NC ${day.ncCount}` : ''}
            </p>
          </div>
          <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>
            {formatDate(day.updatedAt || day.createdAt)}
          </span>
        </div>
      )}
    />
  );
};

export default WrhRecentSheets;
